import { UPDATE_USER, GET_USER, UPDATE_USER_NOTIFICATIONS } from 'actions';

export function user(state = {}, action) {
  switch (action.type) {
    case UPDATE_USER:
    case GET_USER:
    case UPDATE_USER_NOTIFICATIONS:
      return action.user;
    default:
      return state;
  }
}
